export const clientVertical = [
  {
    label: "Clientele Sweet Spot",
    content: (
      <ul className="list-disc pl-5 space-y-3">
        <li>
          SMBs and mid-market organisations: Ready to embrace AWS for measurable
          digital transformation and fast access to new tools and journey
          innovations.
        </li>
        <li>
          Large enterprises and government: With complex, high-volume,
          multi-location operations, demanding data privacy, automation,
          resilience, and rapid peak scaling.
        </li>
        <li>
          Businesses encumbered by legacy platforms and vendor lock-in: Seeking
          a risk-mitigated fast path to the agility and cost benefits of a
          cloud-native AWS foundation.
        </li>
        <li>
          CX innovators and early adopters: Hungry to push boundaries with
          next-generation AI, omnichannel, analytics, and predictive customer
          engagement.
        </li>
        <li>
          Organisations with pressing integration, workflow automation, or data
          governance requirements: Where a disjointed legacy stack limits
          agility and strategic insights.
        </li>
      </ul>
    ),
  },
  {
    label: "Verticals & iCXeed Fit",
    content: (
      <div>
        <p>
          iCXeed's operational models, custom toolkits, and industry frameworks
          are built to address the unique regulatory, integration, and scale
          requirements found in:
        </p>
        <ul>
          <li>
            Pure AWS-native expertise: iCXeed deploys, optimises and manages CX
            AI solutions exclusively on AWS.
          </li>
          <li>
            Agile Engagement: Accelerated discovery, pilot/MVP models, and early
            value realisation — no lock-in, no minimum spend, making innovation
            accessible and risk-managed.
          </li>
          <li>
            Scalable, Global Talent Pool: Our growing CX & technology practice
            provides 24/7 support, rapid scaling for enterprise or surge demand,
            and commercial flexibility.
          </li>
          <li>
            Continuous Innovation & Feedback: Embedded operational know-how and
            CX guidance for clients of all sizes. No client is too small.
          </li>
          <li>
            Extensive AWS Funding & Co-Sell Support: Deep experience leveraging
            AWS Migration Acceleration Program (MAP), Customer Engagement
            Incentive (CEI), and other funding channels for client pilots and
            main deployments.
          </li>
          <li>
            Early Adoption: New AWS CX AI products and feature sets - ROI
            positioning, demos and operational configuration, setting up our
            valued client's success.
          </li>
        </ul>
      </div>
    ),
  },
  {
    label: "Client Pain points addressed",
    content: (
      <ul>
        <li>
          High operational costs and/or inefficiency: Challenges in maintaining
          cost-effective, efficient contact centre operations.
        </li>
        <li>
          Inconsistent customer experience: Across channels (voice, chat, email,
          SMS, social) and languages.
        </li>
        <li>
          Manual, error-prone QA and compliance: Leading to risk exposure and
          inconsistent quality.
        </li>
        <li>
          Limited self-service and automation: Causing high human agent workload
          and dependency.
        </li>
        <li>
          Difficulty integrating disparate systems: Such as CRM, ERP, HR, and
          security platforms.
        </li>
        <li>
          Lack of real-time analytics and insights: Limited visibility into
          operations and missed opportunities for optimisation.
        </li>
        <li>
          Challenges in scaling support: During peak periods or business growth
          phases.
        </li>
        <li>
          Slow innovation cycles: Inability to quickly trial and adopt new AWS
          features.
        </li>
        <li>
          Barriers to migration: Difficulty moving from legacy platforms to
          AWS-native environments.
        </li>
      </ul>
    ),
  },
  {
    label: "How We Win",
    content: (
      <ul className="list-disc pl-5 space-y-3">
        <li>
          Rapid results: Launch new AWS-native CX and automation projects in as
          little as two weeks — no waiting, we move as quickly as our clients
          require us to.
        </li>
        <li>
          Embedded expertise: Founders with 65+ years’ cross-industry success
          guide every engagement, solving real problems and tackling complex
          integrations hands-on.
        </li>
        <li>
          Managed for growth: 24/7 support and proactive optimisation keep
          systems in top shape, freeing account managers to focus on driving new
          opportunities.
        </li>
        <li>
          Innovation first: We pilot new AI and AWS features faster, ensuring
          clients stay ahead in performance, compliance, and capability.
        </li>
        <li>
          Commercial flexibility: Pay-as-you-go, no lock-in, phased rollouts and
          pilots — designed to remove barriers and close AWS deals faster.
        </li>
        <li>
          Deep partnership: We engage early, co-design tailored roadmaps, and
          embed change management — empowering clients and strengthening AWS
          collaboration.
        </li>
        <li>
          Extra mile, every time: Whether it's custom reporting, advanced
          analytics, or supporting expansion into new channels, we deliver more
          than promised.
        </li>
      </ul>
    ),
  },
];
